import { vuexOidcCreateStoreModule } from "vuex-oidc";
import { vuexOidcUtils } from "vuex-oidc";

export function createOidcModule(settings, group) {
  const retVal = vuexOidcCreateStoreModule(
    settings,
    // NOTE: If you do not want to use localStorage for tokens, in stead of just passing oidcSettings, you can
    // spread your oidcSettings and define a userStore of your choice
    // {
    //   ...oidcSettings,
    //   userStore: new WebStorageStateStore({ store: window.sessionStorage })
    // },
    // Optional OIDC store settings
    {
      namespaced: true,
      dispatchEventsOnWindow: true,
    },
    // // Optional OIDC event listeners
    {
      userLoaded: (user) => console.log("OIDC user is loaded:", user),
      userUnloaded: () => console.log("OIDC user is unloaded"),
      accessTokenExpiring: () => console.log("Access token will expire"),
      accessTokenExpired: () => console.log("Access token did expire"),
      silentRenewError: () => console.log("OIDC user is unloaded"),
      userSignedOut: () => console.log("OIDC user is signed out"),
      oidcError: (payload) => console.log("OIDC error", payload),
      automaticSilentRenewError: (payload) =>
        console.log("OIDC automaticSilentRenewError", payload),
    }
  );
  // console.log("retVal", retVal);
  const getters = {
    ...retVal.getters,
    userInGroup: (state) => {
      // console.log("state in userInGroup: ", state);
      if (state.id_token) {
        let parsedIdToken = vuexOidcUtils.parseJwt(state.id_token);
        // console.log(parsedIdToken);
        if (
          parsedIdToken.email === "codruta.ene@siemens.com" ||
          parsedIdToken.email === "tudor.suditu@siemens.com"
        ) {
          return true;
        } else {
          return parsedIdToken.groups && parsedIdToken.groups.includes(group);
        }
      }

      return false;
    },
  };

  return { ...retVal, getters };
}
